import { render, staticRenderFns } from "./ActiveAppointments.vue?vue&type=template&id=e72f88b8&scoped=true"
import script from "./ActiveAppointments.vue?vue&type=script&lang=js"
export * from "./ActiveAppointments.vue?vue&type=script&lang=js"
import style0 from "./ActiveAppointments.vue?vue&type=style&index=0&id=e72f88b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72f88b8",
  null
  
)

export default component.exports